// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="enables-managing-benefit-decision-appeals-on-behalf-of-a-veteran.">Enables managing benefit decision appeals on behalf of a Veteran.</h2>
    </div>
  );
};

export default MarkdownComponent;
